/**
 * Helper utility functions for general application logic
 */

/**
 * Returns formatted copyright string with dynamic current year
 * @param {string} appName - Optional application name (default: "DossierGenAI")
 * @returns {string} Copyright text string
 */
export const getCopyrightText = (appName = "DossierGenAI") => {
  const year = new Date().getFullYear();
  return `© ${year} ${appName}. All Rights Reserved.`;
};

/**
 * Returns current full year
 * @returns {number} Full year
 */
export const getCopyrightYear = () => {
  return new Date().getFullYear();
};

/**
 * Converts a string to camel case (actually PascalCase in this implementation)
 * @param {string} str - String to convert
 * @returns {string} Converted string
 */
export const toCamelCase = (str) => {
  if (!str || typeof str !== "string") {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Extract 1-2 letter uppercase initials from a user's name
 * @param {string} name
 * @returns {string} Initials string (defaults to "U")
 */
export const getInitials = (name = "") => {
  const parts = name.trim().split(" ").filter(Boolean);
  if (!parts.length) return "U";
  return parts.length >= 2
    ? `${parts[0][0]}${parts[1][0]}`.toUpperCase()
    : parts[0].slice(0, 2).toUpperCase();
};
